import React from 'react';
import { RadioGroup } from 'ui';
import { useIntl } from 'react-intl';
import useQueryApiClient from 'utils/useQueryApiClient';
import { Validations } from 'interfaces';
import { FormItemLayout } from 'antd/es/form/Form';
import { RadioChangeEvent } from 'antd/es/radio/interface';

interface EnumProps {
  id: number;
  value: string;
}

interface EnumRadioGroupProps extends Validations {
  name?: (string | number)[] | string | number;
  noStyle?: boolean;
  label?: string;
  disabled?: boolean;
  code: string;
  limited?: string[];
  layout?: FormItemLayout;
  direction?: 'vertical' | 'horizontal';
  buttonStyle?: 'outline' | 'solid';
  onChange?: (e: RadioChangeEvent) => void;
}

const EnumRadioGroup = ({
  name,
  validations,
  noStyle,
  label,
  disabled,
  code,
  limited,
  layout,
  direction = 'vertical',
  buttonStyle,
  onChange,
}: EnumRadioGroupProps) => {
  const intl = useIntl();

  const { data } = useQueryApiClient({
    request: {
      url: `api/v2/enums/${code}`,
    },
  });

  const options =
    data
      ?.filter((entry: EnumProps) =>
        limited?.length ? limited?.includes(entry.value) : true
      )
      .map((entry: EnumProps) => ({
        label: intl.formatMessage({ id: 'enum.' + entry.id }),
        value: entry.value,
      })) || [];

  return (
    <RadioGroup
      name={name}
      validations={validations}
      noStyle={noStyle}
      label={label}
      disabled={disabled}
      direction={direction}
      buttonStyle={buttonStyle}
      options={options}
      onChange={onChange}
    />
  );
};

export default EnumRadioGroup;
